import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { HttpService } from './http/http.service';

@Injectable({
  providedIn: 'root'
})
export class MbpService {

  constructor( private httpService: HttpService) { }

  sampleMbsRecord(object) {
      var request = {
          URL: 'mbp/mbpEntry',
          DATA: object
      };
      return this.httpService.post(request);
  }

  getMbpList(object) {
      var registerList = {
          URL: "mbp/getmbpList/5cee33d225242e023acfb2d4",
          DATA: object
      }
      return this.httpService.post(registerList);
  }

  removembpdetails(_id) {
      var request = {
          URL: "mbp/deletMbpDetail/" + _id
      }
      return this.httpService.get(request);
  }

  getMBPDetailsById(_id) {
      var editlist = {
          URL: "mbp/getMBPDetailsById/" + _id,
      }
      return this.httpService.get(editlist);
  }

  updateMbp(object, id) {
      var request = {
          URL: "mbp/updateMbp/" + id,
          DATA: object
      }
      return this.httpService.post(request);
  }
  generateMbpDocument(object) {
      var request = {
          URL: "mbp/generateMbpDocument",
          DATA: object
      }
      return this.httpService.post(request);
  }

  downloadMbpFile(id, type) {
      var token = localStorage.getItem('token')
      window.location.href = environment.pssServerUrl + "mbp/downloadDocument/" + id + "/" + type + "/" + token;
  }
  downloadMbpPdfFile(id, type) {
      var token = localStorage.getItem('token')
      window.location.href = environment.pssServerUrl + "mbp/downloadPdfDocument/" + id + "/" + type + "/" + token;
  }
}


